import React, {Component} from 'react';

export default class NotFound extends Component {
  render() {
    return (
      <div>
      	<div className="site_wrapper site_wrapper--main">
	        <p>
	        404. Page Not Found.
	        </p>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/NotFound/NotFound.js